import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import { toast } from "react-hot-toast";
import ImageUploadField from "../../../utils/ImageUploadField";

export default function AdminWeMakeItSpecial() {
  const { weMakeItSpecialContent, updateWeMakeItSpecialContent } = useData();

  const [formData, setFormData] = useState({
    upperText: weMakeItSpecialContent.upperText || "",
    heading: weMakeItSpecialContent.heading || "",
    paragraphs: weMakeItSpecialContent.paragraphs || ["", ""],
    buttonText: weMakeItSpecialContent.buttonText || "",
  });

  const [files, setFiles] = useState({
    leftImage: null,
    overlayImage: null,
  });

  const [previewUrls, setPreviewUrls] = useState({
    leftImage: weMakeItSpecialContent.leftImage || "",
    overlayImage: weMakeItSpecialContent.overlayImage || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleParagraphChange = (index, value) => {
    setFormData((prev) => {
      const updatedParagraphs = [...prev.paragraphs];
      updatedParagraphs[index] = value;
      return { ...prev, paragraphs: updatedParagraphs };
    });
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    const file = selectedFiles[0];
    if (!file) return;
    setFiles((prev) => ({ ...prev, [name]: file }));
  };

  const handleClear = (field) => {
    setFiles((prev) => ({ ...prev, [field]: null }));
    setPreviewUrls((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = async () => {
    try {
      await updateWeMakeItSpecialContent(formData, files);
      toast.success("Content updated successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Error updating content.");
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">
        Manage "We Make It Special" Content
      </h2>

      <div className="space-y-4">
        <div>
          <label className="block mb-1 font-semibold text-sm">Upper Text</label>
          <input
            type="text"
            name="upperText"
            value={formData.upperText}
            onChange={handleInputChange}
            className="block w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-sm">Heading</label>
          <input
            type="text"
            name="heading"
            value={formData.heading}
            onChange={handleInputChange}
            className="block w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-sm">Paragraph 1</label>
          <textarea
            value={formData.paragraphs[0]}
            onChange={(e) => handleParagraphChange(0, e.target.value)}
            rows={3}
            className="block w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-sm">Paragraph 2</label>
          <textarea
            value={formData.paragraphs[1]}
            onChange={(e) => handleParagraphChange(1, e.target.value)}
            rows={3}
            className="block w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-sm">Button Text</label>
          <input
            type="text"
            name="buttonText"
            value={formData.buttonText}
            onChange={handleInputChange}
            className="block w-full p-2 border rounded"
          />
        </div>

        <ImageUploadField
          label="Left Image"
          hint="Recommended size: 400×400px (square)"
          aspect="square"
          previewUrl={previewUrls.leftImage}
          file={files.leftImage}
          onChange={(e) => handleFileChange({ target: { name: "leftImage", files: e.target.files } })}
          onClear={() => handleClear("leftImage")}
        />

        <ImageUploadField
          label="Overlay Image"
          hint="Recommended size: 400×400px (square)"
          aspect="square"
          previewUrl={previewUrls.overlayImage}
          file={files.overlayImage}
          onChange={(e) => handleFileChange({ target: { name: "overlayImage", files: e.target.files } })}
          onClear={() => handleClear("overlayImage")}
        />

        <button
          onClick={handleSubmit}
          className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded"
        >
          Update Content
        </button>
      </div>
    </div>
  );
}
